import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import hubDaive from './assets/hubdaive.png';
import agentConfigs from './agentConfigs';
import folder from './assets/folder.png';


function HomePage() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [projects, setProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(true);
  const [menuOpenId, setMenuOpenId] = useState(null);

  const username = localStorage.getItem('username') || 'usuário';
  const agentMap = agentConfigs.reduce((acc, a) => { acc[a.key] = a; return acc; }, {});

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await fetch(`https://hubdaive.com.br/api/verify-token`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error();
      } catch {
        localStorage.removeItem('token');
        navigate('/');
      }
    };
    verifyToken();
  }, [navigate]);

  useEffect(() => {
    const fetchProjects = async () => {
      const token = localStorage.getItem('token');
      try {
        const res = await fetch(`https://hubdaive.com.br/api/projects`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await res.json();
        setProjects(Array.isArray(data) ? data : []);
      } catch {
        setProjects([]);
      } finally {
        setLoadingProjects(false);
      }
    };
    fetchProjects();
  }, []);

  const handleDeleteProject = async (e, projectId) => {
    e.stopPropagation();
    const token = localStorage.getItem('token');
    await fetch(`https://hubdaive.com.br/api/projects/${projectId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    setProjects(prev => prev.filter(p => p.id !== projectId));
    setMenuOpenId(null);
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#000',
      fontFamily: 'Helvetica, Arial, sans-serif',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      padding: '0 4vw 6vh',
      boxSizing: 'border-box',
    }}>
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
        .project-card {
          transition: transform 0.2s ease, border-color 0.2s ease;
        }
        .project-card:hover {
          transform: translateY(-4px);
        }
        .proj-menu-btn { opacity: 0; transition: opacity 0.15s; }
        .project-card:hover .proj-menu-btn { opacity: 1; }

        /* MOBILE */
        @media (max-width: 767px) {
          .project-grid {
            grid-template-columns: 1fr 1fr !important;
          }
          .logo-home {
            width: 35vw !important;
            left: 11% !important;
          }
          .greeting-title {
            font-size: 5vw !important;
          }
          .greeting-sub {
            font-size: 3.5vw !important;
          }
        }
      `}</style>

      {/* Logo */}
      <img
        src={hubDaive}
        alt="logo"
        className="logo-home"
        style={{ position: 'absolute', top: '3%', left: '4%', width: '10vw', height: 'auto' }}
      />

      {/* Saudação */}
      <div style={{
        width: '100%',
        marginTop: '15vh',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(16px)',
        transition: 'opacity 0.5s ease, transform 0.5s ease',
      }}>
        <h1 className="greeting-title" style={{ color: '#fff', fontSize: '3.5vh', fontWeight: '300', letterSpacing: '1px', margin: 0 }}>
          Olá, <span style={{ fontWeight: '700' }}>{username}</span>.
        </h1>
        <p className="greeting-sub" style={{ color: '#555', fontSize: '1.8vh', marginTop: '1vh', fontWeight: '300' }}>
          Em qual projeto você quer trabalhar hoje?
        </p>
      </div>

      {/* Grid de projetos */}
      <div
        className="project-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '20px',
          width: '100%',
          marginTop: '4vh',
        }}
      >
        {loadingProjects ? (
          [0,1,2,3].map(s => (
            <div key={s} style={{
              height: '120px', borderRadius: '16px',
              background: 'linear-gradient(90deg, #1a1a1a 25%, #222 50%, #1a1a1a 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 1.4s infinite'
            }} />
          ))
        ) : projects.length === 0 ? (
          <div style={{ gridColumn: '1 / -1', color: '#444', fontSize: '2vh', textAlign: 'center', marginTop: '10vh' }}>
            Nenhum projeto disponível ainda.
          </div>
        ) : (
          projects.map((project, i) => {
            const agent = agentMap[project.agent_type];
            return (
              <div
                key={project.id}
                className="project-card"
                onClick={() => navigate(`/projects/${project.id}`)}
                style={{
                  backgroundColor: '#0d0d0d',
                  border: `1px solid #222`,
                  borderRadius: '16px',
                  padding: '24px',
                  cursor: 'pointer',
                  position: 'relative',
                  animation: visible ? `fadeInUp 0.5s ease ${i * 0.06}s both` : 'none',
                }}
                onMouseEnter={e => e.currentTarget.style.borderColor = agent?.color || '#444'}
                onMouseLeave={e => { e.currentTarget.style.borderColor = '#222'; if (menuOpenId === project.id) setMenuOpenId(null); }}
              >
                {/* Linha colorida */}
                <div style={{ width: '30px', height: '3px', backgroundColor: agent?.color || '#444', marginBottom: '14px' }} />

                {/* Nome */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                  <img src={folder} alt="folder" style={{ width: 'auto', height: '1.8vh', filter: 'invert(100%)', flexShrink: 0 }} />
                  <span style={{ color: '#fff', fontWeight: '700', fontSize: '1.8vh', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {project.name}
                  </span>
                </div>

                {/* Descrição */}
                {project.description && (
                  <p style={{ color: '#555', fontSize: '1.3vh', margin: '0 0 12px', lineHeight: '1.5', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                    {project.description}
                  </p>
                )}

                {/* Tag do agente */}
                {agent && (
                  <span style={{
                    backgroundColor: agent.color + '18',
                    color: agent.color,
                    border: `1px solid ${agent.color}33`,
                    borderRadius: '6px',
                    padding: '3px 8px',
                    fontSize: '1.2vh',
                    fontWeight: '600'
                  }}>
                    {agent.name}
                  </span>
                )}

                {/* Menu */}
                <span
                  className="proj-menu-btn"
                  onClick={e => { e.stopPropagation(); setMenuOpenId(menuOpenId === project.id ? null : project.id); }}
                  style={{ position: 'absolute', top: '16px', right: '16px', color: '#fff', fontSize: '1.6vh', cursor: 'pointer', padding: '4px' }}
                >
                  ...
                </span>

                {menuOpenId === project.id && (
                  <div onClick={e => e.stopPropagation()} style={{ position: 'absolute', right: '16px', top: '40px', backgroundColor: '#1a1a1a', border: '1px solid #333', borderRadius: '8px', zIndex: 100, minWidth: '130px', overflow: 'hidden' }}>
                    <div
                      onClick={(e) => handleDeleteProject(e, project.id)}
                      style={{ padding: '10px 14px', fontSize: '1.2vh', color: '#ff4444', cursor: 'pointer' }}
                      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#262626'}
                      onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      🗑️ Deletar
                    </div>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default HomePage;